module.exports = __webpack_public_path__ + "img/trouserwaistcircumference.2202ba4b.jpeg";